"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildVocabTimeline;
require("regenerator-runtime/runtime");
// setup
const helpers_1 = require("../shared/helpers");
const taskSetup_1 = require("../taskSetup");
// trials
const trials_1 = require("../shared/trials");
const config_1 = require("./helpers/config");
const taskStore_1 = require("../../taskStore");
const preloadSharedAudio_1 = require("../shared/helpers/preloadSharedAudio");
function buildVocabTimeline(config, mediaAssets) {
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    const translations = (0, taskStore_1.taskStore)().translations;
    const validationErrorMap = {};
    const { runCat } = (0, taskStore_1.taskStore)();
    const { semThreshold } = (0, taskStore_1.taskStore)();
    const layoutConfigMap = {};
    for (const c of corpus) {
        const { itemConfig, errorMessages } = (0, config_1.getLayoutConfig)(c, translations, mediaAssets);
        layoutConfigMap[c.itemId] = itemConfig;
        if (errorMessages.length) {
            validationErrorMap[c.itemId] = errorMessages.join('; ');
        }
    }
    if (Object.keys(validationErrorMap).length) {
        console.error('The following errors were found');
        console.table(validationErrorMap);
        throw new Error('Something went wrong. Please look in the console for error details');
    }
    // organize media assets into batches for preloading
    const batchSize = 25;
    const batchedCorpus = (0, helpers_1.batchTrials)(corpus, batchSize);
    const batchedMediaAssets = (0, helpers_1.batchMediaAssets)(mediaAssets, batchedCorpus, ['answer', 'distractors']);
    // counter for next batch to preload
    let currPreloadBatch = 0;
    const initialPreload = runCat ? (0, helpers_1.createPreloadTrials)(mediaAssets).default : (0, preloadSharedAudio_1.preloadSharedAudio)();
    // does not matter if trial has properties that don't belong to that type
    const trialConfig = {
        trialType: 'audio',
        responseAllowed: true,
        promptAboveButtons: true,
        task: config.task,
        layoutConfig: {
            showPrompt: false,
        },
        layoutConfigMap,
        terminateCat: false,
    };
    function preloadBatch() {
        timeline.push((0, helpers_1.createPreloadTrials)(batchedMediaAssets[currPreloadBatch]).default);
        currPreloadBatch++;
    }
    const stimulusBlock = {
        timeline: [{ ...trials_1.setupStimulus, stimulus: '' }, (0, trials_1.afcStimulusTemplate)(trialConfig)],
        // true = execute normally, false = skip
        conditional_function: () => {
            if ((0, taskStore_1.taskStore)().skipCurrentTrial) {
                (0, taskStore_1.taskStore)('skipCurrentTrial', false);
                return false;
            }
            if (runCat && taskSetup_1.cat._seMeasurement < semThreshold) {
                return false;
            }
            return true;
        },
    };
    const timeline = [initialPreload, initialTimeline];
    if (runCat) {
        // seperate out corpus to get cat/non-cat blocks
        const corpora = (0, helpers_1.prepareCorpus)(corpus);
        // instruction block (non-cat)
        corpora.ipLight.forEach((trial) => {
            timeline.push({ ...trials_1.fixationOnly, stimulus: '' });
            timeline.push((0, trials_1.afcStimulusTemplate)(trialConfig, trial));
        });
        // push in starting block
        corpora.start.forEach((trial) => {
            timeline.push({ ...trials_1.fixationOnly, stimulus: '' });
            timeline.push((0, trials_1.afcStimulusTemplate)(trialConfig, trial));
        });
        // cat block
        const numOfCatTrials = corpora.cat.length;
        (0, taskStore_1.taskStore)('totalTestTrials', numOfCatTrials);
        for (let i = 0; i < numOfCatTrials; i++) {
            timeline.push(stimulusBlock);
        }
        // select up to 5 random items from unnormed portion of corpus
        const unnormedTrials = (0, helpers_1.selectNItems)(corpora.unnormed, 5);
        // random set of unvalidated items at end
        const unnormedBlock = {
            timeline: unnormedTrials.map((trial) => (0, trials_1.afcStimulusTemplate)(trialConfig, trial)),
        };
        timeline.push(unnormedBlock);
    }
    else {
        const numOfTrials = (0, taskStore_1.taskStore)().totalTrials;
        (0, taskStore_1.taskStore)('totalTestTrials', (0, helpers_1.getRealTrials)(corpus));
        for (let i = 0; i < numOfTrials; i++) {
            if (i % batchSize === 0) {
                preloadBatch();
            }
            timeline.push(stimulusBlock);
        }
    }
    (0, taskSetup_1.initializeCat)();
    // final screens
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
